import { supabase } from "@/integrations/supabase/client";
import type { Category } from "@/types/ecommerce";

export const categoriesService = {
  async list(activeOnly = true): Promise<Category[]> {
    let q = supabase.from("categories").select("*").order("sort_order", { ascending: true });
    if (activeOnly) q = q.eq("is_active", true);
    const { data, error } = await q;
    if (error) throw error;
    return (data ?? []) as unknown as Category[];
  },

  async getBySlug(slug: string): Promise<Category | null> {
    const { data, error } = await supabase.from("categories").select("*").eq("slug", slug).maybeSingle();
    if (error) throw error;
    return data as unknown as Category | null;
  },

  async create(input: Partial<Category> & { name: string; slug: string }) {
    const { data, error } = await supabase.from("categories").insert(input as any).select().single();
    if (error) throw error;
    return data as unknown as Category;
  },

  async update(id: string, patch: Partial<Category>) {
    const { data, error } = await supabase
      .from("categories")
      .update(patch as any)
      .eq("id", id)
      .select()
      .single();
    if (error) throw error;
    return data as unknown as Category;
  },

  async remove(id: string) {
    const { error } = await supabase.from("categories").delete().eq("id", id);
    if (error) throw error;
  },

  async uploadImage(file: File): Promise<string> {
    const ext = file.name.split(".").pop() ?? "jpg";
    const path = `${Date.now()}-${Math.random().toString(36).slice(2)}.${ext}`;
    const { error } = await supabase.storage.from("category-images").upload(path, file, {
      cacheControl: "3600",
      upsert: false,
    });
    if (error) throw error;
    const { data } = supabase.storage.from("category-images").getPublicUrl(path);
    return data.publicUrl;
  },

  /**
   * Persiste a nova ordem de exibição. Recebe os IDs já na ordem desejada
   * e grava `sort_order` sequencial (10, 20, 30…) para deixar espaço para
   * futuras inserções manuais.
   */
  async reorder(orderedIds: string[]): Promise<void> {
    await Promise.all(
      orderedIds.map((id, index) =>
        supabase
          .from("categories")
          .update({ sort_order: (index + 1) * 10 })
          .eq("id", id),
      ),
    );
  },
};